<script lang="ts">
  import { type StampFromSet, type PhilatelicSet } from '@briefmarken_katalog/types';
  import PictureOverlay from '../PictureOverlay.svelte';
  import { t } from '$lib/i18n';

  import './row.css';

  const { stamps, fetchFullSet }: {
    stamps: StampFromSet[];
    fetchFullSet: () => Promise<PhilatelicSet | null>;
  } = $props<{
    stamps: StampFromSet[];
    fetchFullSet: () => Promise<PhilatelicSet | null>;
  }>();

  const n = stamps.length;
  const cols = Math.max(1, Math.ceil(Math.sqrt(n)));
  // Clamped so thumbnails stay visible on narrow (mobile) viewports; unchanged on typical desktops
  const imageWidth = n > 4 ? 'clamp(24px, 1.5vw, 48px)' : `clamp(32px, calc(5vw / ${cols}), 96px)`;
  const hasAnyPicture = stamps.some(s => s.pictures?.[0]);

  let isOverlayOpen = $state(false);
  let imageSrc = $state<string | undefined>(undefined);

  async function openOverlay(index: number) {
    const full = await fetchFullSet();
    const hiRes = full?.stamps?.[index]?.pictures?.[0];
    if (!hiRes) return;
    imageSrc = hiRes.base64 || hiRes.thumbnail;
    isOverlayOpen = true;
  }
</script>

{#if hasAnyPicture}
<div style="display: grid; grid-template-columns: repeat({cols}, {imageWidth}); gap: 2px;">
  {#each stamps as stamp, i}
    {#if stamp.pictures?.[0]}
      <!-- svelte-ignore a11y_no_static_element_interactions -->
      <div
        class="card-3d card-3d-anim"
        style="width: fit-content; cursor: pointer;"
        onclick={() => openOverlay(i)}
        onkeydown={() => {}}
      >
        <img
          src={stamp.pictures[0].thumbnail ?? stamp.pictures[0].base64}
          alt={$t('alt.stamp')}
          style="width: {imageWidth}; height: auto; object-fit: contain; display: block;"
        />
      </div>
    {:else}
      <div style="width: {imageWidth}; aspect-ratio: 1; background: #e5e7eb; border-radius: 2px;"></div>
    {/if}
  {/each}
</div>

<PictureOverlay
  src={imageSrc}
  alt={$t('alt.aStamp')}
  bind:open={isOverlayOpen}
/>
{/if}
